module.exports = __webpack_public_path__ + "img/d6.5e5ba21b.png";